import axios from 'axios';
import { useCallback, useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const SearchBar = ({ onSearch,loading,initialFilters  }) => {

  // State management
  
  const [location, setLocation] = useState('');
  const [showLocationDropdown, setShowLocationDropdown] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showDateDropdown, setShowDateDropdown] = useState(false);
  const [counts, setCounts] = useState({ adults: 1, children: 0, infants: 0 });
  const [showGuestDropdown, setShowGuestDropdown] = useState(false);

  const [mobileDropdown, setMobileDropdown] = useState(null); // 'location', 'date', 'guests' or null
  const [showCalendarView, setShowCalendarView] = useState(false); // for calender in mobile-view
  const [cities, setCities] = useState([]);



  // Refs for DOM manipulation - exactly like original
  const searchBarRef = useRef(null);
  const highlightRef = useRef(null);
  const locationWrapperRef = useRef(null);
  const dateWrapperRef = useRef(null);
  const guestWrapperRef = useRef(null);
  const locationInputRef = useRef(null);
  const dateInputRef = useRef(null);
  const guestInputRef = useRef(null);
  const blurTimeoutRef = useRef(null);

   const [showMbSearchFilter, setShowMbSearchFilter] = useState(false);

  // 🔹 Handle input click → Show filter
  const handleMbSearchClick = () => {
    setShowMbSearchFilter(true);
  };

  // 🔹 Handle cross button → Close filter
  const handleMbSearchClose = () => {
    setShowMbSearchFilter(false);
  };

  // Close all other dropdowns - helper function
  const closeAllDropdowns = useCallback(() => {
    setShowLocationDropdown(false);
    setShowDateDropdown(false);
    setShowGuestDropdown(false);
  }, []);

  useEffect(() => {
      const fetchCities = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_API_BASE}/getCities`
          );
          if (res.data && res.data.data) {
            setCities(res.data.data);
          }
        } catch (err) {
          console.error("Error fetching cities:", err);
        }
      };
      fetchCities();
    }, []);




useEffect(() => {
  if (!initialFilters) return;

  setLocation(initialFilters.search || "");
  // setStartDate(initialFilters.date ? new Date(initialFilters.date.split(" to ")[0]) : null);
  // setEndDate(initialFilters.date && initialFilters.date.includes(" to ")
  //   ? new Date(initialFilters.date.split(" to ")[1])
  //   : null
  // );
   setStartDate(
    initialFilters.arrive
      ? new Date(initialFilters.arrive)
      : null
  );

  setEndDate(
    initialFilters.depart
      ? new Date(initialFilters.depart)
      : null
  );
  setCounts({
    adults: initialFilters.adults || 0,
    children: initialFilters.children || 0,
    infants: initialFilters.infants || 0,
  });
}, []);   // 👈 run only ONCE


const showSuggestions = useCallback(() => {
  const query = (location || "").toLowerCase();

  const filtered = cities
    .filter((c) => c.name.toLowerCase().includes(query))
    .sort((a, b) => a.name.localeCompare(b.name)); // ✅ sort alphabetically

  if (filtered.length > 0 || query.trim() !== "") {
    setShowLocationDropdown(true);
  } else {
    setShowLocationDropdown(false);
  }
}, [location, cities]);



  // Clear all function for mobile
const clearAll = () => {
  setLocation('');
  setStartDate(null);
  setEndDate(null);
  setCounts({ adults: 0, children: 0, infants: 0 });
  setMobileDropdown(null);
  setShowCalendarView(false);
};




  // Move highlight - exactly as original with getBoundingClientRect
  const moveHighlight = useCallback((wrapper) => {
    if (!searchBarRef.current || !highlightRef.current || !wrapper.current)
      return;

    const rect = wrapper.current.getBoundingClientRect();
    const barRect = searchBarRef.current.getBoundingClientRect();

    // Remove highlight-active from all wrappers first - exactly as original
    [locationWrapperRef, dateWrapperRef, guestWrapperRef].forEach((ref) => {
      if (ref.current) {
        ref.current.classList.remove('highlight-active');
      }
    });

    // Set highlight position and add active class
    highlightRef.current.style.width = `${rect.width}px`;
    highlightRef.current.style.left = `${rect.left - barRect.left}px`;
    wrapper.current.classList.add('highlight-active');
  }, []);

  // Reset highlight - exactly as original
  const resetHighlight = useCallback(() => {
    if (highlightRef.current) {
      highlightRef.current.style.width = '0';
    }
    [locationWrapperRef, dateWrapperRef, guestWrapperRef].forEach((ref) => {
      if (ref.current) {
        ref.current.classList.remove('highlight-active');
      }
    });
  }, []);

  // Location input handlers - exactly as original
  const handleLocationInput = (e) => {
    setLocation(e.target.value);
    showSuggestions();
  };

  const handleLocationFocus = () => {
    // Close other dropdowns first - FIX
    setShowDateDropdown(false);
    setShowGuestDropdown(false);
    showSuggestions();
    moveHighlight(locationWrapperRef);
  };

  const handleLocationClick = () => {
    // Close other dropdowns first - FIX
    setShowDateDropdown(false);
    setShowGuestDropdown(false);
    moveHighlight(locationWrapperRef);
  };

  // Blur with 150ms timeout - exactly as original
  const handleLocationBlur = () => {
    blurTimeoutRef.current = setTimeout(() => {
      setShowLocationDropdown(false);
    }, 150);
  };

  // Mousedown event (not click) - exactly as original
  const handleLocationSelect = (locationName) => {
    if (blurTimeoutRef.current) {
      clearTimeout(blurTimeoutRef.current);
    }
    setLocation(locationName);
    setShowLocationDropdown(false);
    setTimeout(() => {
      if (dateInputRef.current) {
        dateInputRef.current.focus();
        handleDateClick();            
      }
    }, 100);
  };

  const clearLocation = () => {
    setLocation('');
    setShowLocationDropdown(false);
  };

  // Date handlers - exactly as original with FIXES
  const handleDateClick = (e) => {
    // e.stopPropagation(); // Exactly as original
    // Close other dropdowns first - FIX
    setShowLocationDropdown(false);
    setShowGuestDropdown(false);
    setShowDateDropdown((prev) => !prev);
    moveHighlight(dateWrapperRef);
  };

  const handleDateFocus = () => {
    // Close other dropdowns first - FIX
    setShowLocationDropdown(false);
    setShowGuestDropdown(false);
    moveHighlight(dateWrapperRef);
  };
const formatDate = (date) => {
  if (!date) return '';
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().split('T')[0];
};



  const formatDateRange = () => {
  if (startDate && endDate) {
    const start = formatDate(startDate);
    const end = formatDate(endDate);
    return `${start} to ${end}`;
  } else if (startDate) {
    return formatDate(startDate);
  }
  return '';
};

  

  // Date shortcuts - exactly as original logic
  const handleDateShortcut = (type) => {
    const today = new Date();
    let start, end;

    if (type === 'today') {
      start = today;
      end = today;
    } else if (type === 'tomorrow') {
      start = new Date(today);
      start.setDate(today.getDate() + 1);
      end = start;
    } else if (type === 'weekend') {
      start = new Date(today);
      const day = start.getDay();
      const daysUntilFriday = (5 - day + 7) % 7;
      start.setDate(start.getDate() + daysUntilFriday);
      end = new Date(start);
      end.setDate(start.getDate() + 2);
    }

    setStartDate(start);
    setEndDate(end);
  };

  const clearDates = () => {
    setStartDate(null);
    setEndDate(null);
  };

  // Guest handlers - exactly as original with FIXES
  const handleGuestClick = () => {
    // Close other dropdowns first - FIX
    setShowLocationDropdown(false);
    setShowDateDropdown(false);
    setShowGuestDropdown((prev) => !prev);
    moveHighlight(guestWrapperRef);
  };

  const handleGuestFocus = () => {
    // Close other dropdowns first - FIX
    setShowLocationDropdown(false);
    setShowDateDropdown(false);
    moveHighlight(guestWrapperRef);
  };



  const handleGuestDropdownClick = (e) => {
  if (e.target.tagName === "BUTTON") {
    const row = e.target.closest(".guest-row");
    if (!row) return;

    const countEl = row.querySelector(".count");
    if (!countEl) return;

    const type = countEl.dataset.type;

    setCounts((prev) => {
      const totalAdultsChildren = prev.adults + prev.children;

      // ✅ Plus button logic
      if (e.target.classList.contains("plus")) {
        // combined limit for adults + children = 16
        if (type === "adults" || type === "children") {
          if (totalAdultsChildren >= 16) return prev;
        }
        // infants max 5
        if (type === "infants" && prev.infants >= 5) return prev;

        return {
          ...prev,
          [type]: prev[type] + 1,
        };
      }

      // ✅ Minus button logic
      if (e.target.classList.contains("minus")) {
        return {
          ...prev,
          [type]: Math.max(0, prev[type] - 1),
        };
      }

      return prev;
    });
  }
};



const updateGuestInput = () => {
  const { adults, children, infants } = counts;
  const totalGuests = adults + children;

  const guestText = totalGuests > 0 ? `${totalGuests} Guest${totalGuests > 1 ? 's' : ''}` : '';
  const infantText = infants > 0 ? `${infants} Infant${infants > 1 ? 's' : ''}` : '';

  if (guestText && infantText) return `${guestText}, ${infantText}`;
  if (guestText) return guestText;
  if (infantText) return infantText;

  return '';
};



  const clearGuests = () => {
    setCounts({ adults: 0, children: 0, infants: 0 });
  };

 

// const handleClick = () => {
//    const selectedCity = cities.find(
//     (city) => city?.name?.toLowerCase() === location?.toLowerCase()
//   );

//   let id;
//   if (selectedCity) {
//     id = selectedCity.id;
//   } else if (location?.trim()) {
//     id = location.trim();
//   } else {
//     id = null;
//   }

//   let date = "";
//   if (startDate && endDate) {
//     date = `${formatDate(startDate)} to ${formatDate(endDate)}`;
//   } else if (startDate) {
//     date = formatDate(startDate);
//   }

//   const guest = counts.adults + counts.children + counts.infants;

//   onSearch({
//     id,
//     type: selectedCity?.type || "city",
//     name: selectedCity?.name || location?.trim(),
//     date,
//     guest,
//     adults: counts.adults,
//     children: counts.children,
//     infants: counts.infants
//   });
// };





  // Mobile dropdown handler


  const handleClick = () => {
  const searchVal = location?.trim().toLowerCase();

  const match = cities.find(
    (item) =>
      item.name?.toLowerCase() === searchVal ||
      item.country_name?.toLowerCase() === searchVal
  );

  const finalName = match
    ? match.name || match.country_name
    : location.trim();

  // Date formatting
  let date = "";
  if (startDate && endDate) {
    date = `${formatDate(startDate)} to ${formatDate(endDate)}`;
  } else if (startDate) {
    date = formatDate(startDate);
  }

  const guest = counts.adults + counts.children + counts.infants;

  onSearch({
    name: finalName,
     // 👇 separate dates
    arrive: startDate ? formatDate(startDate) : "",
    depart: endDate ? formatDate(endDate) : "",
    guest,
    adults: counts.adults,
    children: counts.children,
    infants: counts.infants,
  });
};


  const handleMobileDropdownClick = (type) => {
  if (mobileDropdown === type) {
    setMobileDropdown(null);
  } else {
    setMobileDropdown(type);
  }
  setShowCalendarView(false);
};

// Mobile location select handler
const handleMobileLocationSelect = (locationName) => {
  setLocation(locationName);
  setMobileDropdown(null);
};

// Mobile date shortcut handler
const handleMobileDateShortcut = (type) => {
  handleDateShortcut(type); // reuse existing function
  setMobileDropdown(null);
};


  // Document click handler - exactly as original with PROPER TARGETING
  useEffect(() => {
    const handleDocumentClick = (e) => {
      // Close location dropdown if clicking outside location wrapper
      if (!e.target.closest('.location-wrapper')) {
        setShowLocationDropdown(false);
      }

      // Close date dropdown if clicking outside date wrapper
      if (!e.target.closest('.date-wrapper')) {
        setShowDateDropdown(false);
      }

      // Close guest dropdown if clicking outside guests wrapper
      if (!e.target.closest('.guests-wrapper')) {
        setShowGuestDropdown(false);
      }

      // Reset highlight if clicking outside any input wrapper
      if (!e.target.closest('.input-wrapper')) {
        resetHighlight();
      }

      if (mobileDropdown && !e.target.closest('.mobile-dropdown') && !e.target.closest('.src_fld_area')) {
      setMobileDropdown(null);
    }

    };

    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
      if (blurTimeoutRef.current) {
        clearTimeout(blurTimeoutRef.current);
      }
    };
  }, [resetHighlight, , mobileDropdown]);


const searchText = typeof location === "string" ? location : "";

// ✅ Remove duplicates using Map and ensure alphabetical sorting
// const uniqueCities = Array.from(
//   new Map(cities.map((c) => [c.name.toLowerCase(), c])).values()
// );

// const filteredCities = uniqueCities
//   .filter(
//     (city) =>
//       city.name &&
//       city.name.toLowerCase().includes(searchText.toLowerCase())
//   )
//   .sort((a, b) => a.name.localeCompare(b.name));




// if (
//   searchText.trim() !== "" &&
//   !cities.some(
//     (city) => city.name.toLowerCase() === searchText.toLowerCase()
//   )
// ) {
//   filteredCities.unshift({
//     city_id: null,
//     city_name: searchText.trim(),
//     isTyped: true,
//   });
// }

const uniqueCities = Array.from(
  new Map(cities.map((c) => [c.name.toLowerCase(), c])).values()
);

let filteredCities = uniqueCities
  .filter(
    (city) =>
      city.name &&
      city.name.toLowerCase().includes(searchText.toLowerCase())
  )
  .sort((a, b) => a.name.localeCompare(b.name));

// ⭐ Add “typed value” at the top if not matched
if (
  searchText.trim() !== "" &&
  !cities.some(
    (city) => city.name.toLowerCase() === searchText.toLowerCase()
  )
) {
  filteredCities.unshift({
    id: null,
    name: searchText.trim(),   // 👈 use name to avoid undefined
    isTyped: true,
  });
}


  return (
    <>
    <div className="frm_al_fldss shedowss newssses mb_view_hide">
      <div className="search-bar" ref={searchBarRef}>
        {/* Sliding highlight */}
        <div className="highlight" ref={highlightRef}></div>

        {/* Location */}
        <div
          className="input-wrapper location-wrapper"
          ref={locationWrapperRef}
        >
          <label className="lbessl">Where</label>
          <input
            ref={locationInputRef}
            type="text"
            placeholder="Search destinations"
            className="input"
            value={location}
            onChange={handleLocationInput}
            onFocus={handleLocationFocus}
            onClick={handleLocationClick}
            onBlur={handleLocationBlur}
            autoComplete="off"
          />
          {location && (
            <button
              className="clear-btn"
              onClick={clearLocation}
              style={{ display: 'flex' }}
            >
              ×
            </button>
          )}
          {showLocationDropdown && filteredCities.length > 0 && (
  <ul className="dropdown" style={{ display: 'block' }}>
    {filteredCities.map((city) => {
      
      return (
        // <li 
        //   key={city.city_id || city.name} 
        //   onMouseDown={() => handleLocationSelect(city.name)}
        // >
        //   {city.isTyped 
        //     ? city.name // ✅ typed value
        //     : city.name // ✅ API value
        //   }
        // </li>
        <li 
  key={city.id || city.name} 
  onMouseDown={() => handleLocationSelect(city.name)}
>
  {city.name}
</li>

      );
    })}
  </ul>
)}


        </div>

        {/* Date */}
        <div className="input-wrapper date-wrapper" ref={dateWrapperRef}>
          <label className="lbessl">Date</label>
          <input
            ref={dateInputRef}
            type="text"
            placeholder="Add dates"
            className="input"
            value={formatDateRange()}
            onFocus={handleDateFocus}
            onClick={handleDateClick}
            readOnly
          />
          {(startDate || endDate) && (
            <button
              className="clear-btn"
              onClick={clearDates}
              style={{ display: 'flex' }}
            >
              ×
            </button>
          )}

          {/* Custom Date Dropdown */}
          {showDateDropdown && (
            <div className="date-dropdown" style={{ display: 'flex' }}>
              <div className="date-shortcuts">
                <button
                  onClick={() => handleDateShortcut('today')}
                  data-type="today"
                >
                  Today
                </button>
                <button
                  onClick={() => handleDateShortcut('tomorrow')}
                  data-type="tomorrow"
                >
                  Tomorrow
                </button>
                <button
                  onClick={() => handleDateShortcut('weekend')}
                  data-type="weekend"
                >
                  This weekend
                </button>
              </div>
              <div className="date-calendar">
                <DatePicker
                  selected={startDate}
                  onChange={(dates) => {
                    const [start, end] = dates;
                    setStartDate(start);
                    setEndDate(end);
                  }}
                  startDate={startDate}
                  endDate={endDate}
                  minDate={new Date()}
                  selectsRange
                  inline
                />
              </div>
            </div>
          )}
        </div>

        {/* Guests */}
        <div className="input-wrapper guests-wrapper" ref={guestWrapperRef}>
          <label className="lbessl">Who</label>
          <input
            ref={guestInputRef}
            type="text"
            placeholder="Guests"
            className="input guests"
            value={updateGuestInput()}
            onFocus={handleGuestFocus}
            onClick={handleGuestClick}
            readOnly
          />
          {counts.adults + counts.children + counts.infants > 0 && (
            <button
              className="clear-btn"
              onClick={clearGuests}
              style={{ display: 'flex' }}
            >
              ×
            </button>
          )}
          {showGuestDropdown && (
            <div
              className="guest-dropdown"
              style={{ display: 'block' }}
              onClick={handleGuestDropdownClick}
            >
              <div className="guest-row">
                <span>Adults</span>
                <div className="counter">
                  <button className="minus">-</button>
                  <span className="count" data-type="adults">
                    {counts.adults}
                  </span>
                  <button className="plus" disabled={counts.adults >= 16}>+</button>
                </div>
              </div>
              <div className="guest-row">
                <span>Children</span>
                <div className="counter">
                  <button className="minus">-</button>
                  <span className="count" data-type="children">
                    {counts.children}
                  </span>
                  <button className="plus">+</button>
                </div>
              </div>
              <div className="guest-row">
                <span>Infants</span>
                <div className="counter">
                  <button className="minus">-</button>
                  <span className="count" data-type="infants">
                    {counts.infants}
                  </span>
                  <button className="plus">+</button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Search Button */}
       <button className="search-btn" onClick={handleClick} disabled={loading}>
  {loading ? (
    <span className="spinner"></span> // spinner
  ) : (
    <img src="/images/search.svg" alt="search" />
  )}
</button>

      </div>
    </div>
    {/* Mobile Search Section */}
      <div className="mb_view_show">
         <div className="mb_search_area" style={{ display: showMbSearchFilter ? "none" : "block" }} >
		  <img src="/images/search.png" className="sr_icnns" alt="" />
          <input type="text" name="search" placeholder="Search here" onClick={handleMbSearchClick} />
         </div>

        {/* Mobile Search Filter */}
        <div
          className={`mb_search_filter ${showMbSearchFilter ? 'show' : ''}`} >
          <div className="cross" onClick={handleMbSearchClose}><i className="fa fa-times"></i></div>
          <div className="serc_area_main">
		   <div className="src_fld_area">
  <h4>Where?</h4>
  <div className="src_flidss">
    <img src="images/search.png" className="sr_icnns" alt="" />
    <input 
      type="text" 
      name="search" 
      placeholder="Search destinations"
      value={location}
      onChange={(e) => setLocation(e.target.value)}
      onClick={() => handleMobileDropdownClick('location')}
    />
  </div>
  {/* Mobile Location Dropdown */}
  {mobileDropdown === 'location' &&
  filteredCities.map((city) => (
    <div
      key={city.city_id}
      className="location-item"
      onClick={() => handleMobileLocationSelect(city.name)}
    >
      <div className="location-details">
        <div className="location-name">{city.name}</div>
        <div className="location-desc">Popular destination</div>
      </div>
    </div>
  ))}
</div>

		   
		   <div className="src_fld_area">
  <div className="adr_fildss" onClick={() => handleMobileDropdownClick('date')}>
    <span>When</span>
    <span className="bllds">{formatDateRange() || 'Add dates'}</span>
  </div>
  
{/* Mobile Date Dropdown */}
{mobileDropdown === 'date' && (
  <div className="mobile-dropdown date-dropdown">
    <div className="dropdown-header">
      <h4>
        {showCalendarView && (
          <button 
  className="back-btn" 
  onClick={(e) => {
    e.stopPropagation();
    setShowCalendarView(false);
  }}
>
  ← 
</button>

        )}
        When?
      </h4>
    </div>
    
    {!showCalendarView ? (
      // Date Options View
      <div className="date-options">
        <div className="date-option" onClick={(e) => {
  e.stopPropagation();
  handleMobileDateShortcut('today');
}}>
  <div className="date-label">Today</div>
  {/* <div className="date-value">6 Sept</div> */}
</div>
<div className="date-option" onClick={(e) => {
  e.stopPropagation();
  handleMobileDateShortcut('tomorrow');
}}>
  <div className="date-label">Tomorrow</div>
  {/* <div className="date-value">7 Sept</div> */}
</div>
<div className="date-option weekend" onClick={(e) => {
  e.stopPropagation();
  handleMobileDateShortcut('weekend');
}}>
  <div className="date-label">This weekend</div>
  {/* <div className="date-value">6-7 Sept</div> */}
</div>

        <div className="date-option choose-dates" onClick={(e) => {
  e.stopPropagation();
  setShowCalendarView(true);
}}>
  <div className="date-label">Choose dates</div>
  <div className="date-arrow">→</div>
</div>
      </div>
    ) : (
      // Calendar View
      <div className="calendar-view">
        <DatePicker
          selected={startDate}
          onChange={(dates) => {
            const [start, end] = dates;
            setStartDate(start);
            setEndDate(end);
          }}
          startDate={startDate}
          endDate={endDate}
          selectsRange
          inline
        />
      </div>
    )}
  </div>
)}


</div>

		   
		   <div className="src_fld_area">
  <div className="adr_fildss" onClick={() => handleMobileDropdownClick('guests')}>
    <span>Who</span>
    <span className="bllds">{updateGuestInput() || 'Add guests'}</span>
  </div>
  {/* Mobile Guest Dropdown */}
  {/* Mobile Guest Dropdown */}
{mobileDropdown === 'guests' && (
  <div className="mobile-dropdown guest-dropdown">
    <div className="dropdown-header">
      <h4>Who?</h4>
    </div>
    <div className="guest-options" onClick={handleGuestDropdownClick}>
      <div className="guest-row">
        <div className="guest-info">
          <div className="guest-type">Adults</div>
          <div className="guest-desc">Ages 13 or above</div>
        </div>
        <div className="counter">
          <button className="counter-btn minus">-</button>
          <span className="count" data-type="adults">{counts.adults}</span>
          <button className="counter-btn plus">+</button>
        </div>
      </div>
      <div className="guest-row">
        <div className="guest-info">
          <div className="guest-type">Children</div>
          <div className="guest-desc">Ages 2-12</div>
        </div>
        <div className="counter">
          <button className="counter-btn minus">-</button>
          <span className="count" data-type="children">{counts.children}</span>
          <button className="counter-btn plus">+</button>
        </div>
      </div>
      <div className="guest-row">
        <div className="guest-info">
          <div className="guest-type">Infants</div>
          <div className="guest-desc">Under 2</div>
        </div>
        <div className="counter">
          <button className="counter-btn minus">-</button>
          <span className="count" data-type="infants">{counts.infants}</span>
          <button className="counter-btn plus">+</button>
        </div>
      </div>
    </div>
  </div>
)}

</div>

		   
		   
		   {!mobileDropdown && (
  <div className="btm_araeaas">
    <button type="text" className="clearss" value="" onClick={clearAll}>Clear all</button>
    <button type="text" className="serassh" value="" onClick={handleClick}><img src="/images/search.png" className="sr_icnns" alt="" /> Search</button>
  </div>
)}

		  </div>
          {/* Add any mobile filter content here */}
        </div>
      </div>
    </>

  );
};

export default SearchBar;
